interface FlowIndicatorProps {
  activeStep: 1 | 2 | 3 | 4 | 5;
}

const STEPS = [
  { label: 'Opzeg', color: 'bg-amber-500' },
  { label: 'Uitg. PB', color: 'bg-orange-500' },
  { label: 'Leeg', color: 'bg-neutral-400' },
  { label: 'Kand.', color: 'bg-blue-500' },
  { label: 'Ing. PB', color: 'bg-moss-primary' },
];

export const FlowIndicator = ({ activeStep }: FlowIndicatorProps) => {
  return (
    <div className="flex items-center gap-0.5 w-full">
      {STEPS.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === activeStep;
        const isPast = stepNumber < activeStep;
        return (
          <div key={index} className="flex items-center flex-1 min-w-0">
            <div className="flex flex-col items-center flex-shrink-0">
              <div
                className={`w-2 h-2 rounded-full transition-colors ${
                  isActive ? step.color : isPast ? 'bg-neutral-300' : 'bg-neutral-200'
                }`}
              />
              <span
                className={`text-[9px] mt-0.5 whitespace-nowrap ${
                  isActive ? 'text-neutral-primary font-medium' : 'text-neutral-secondary-mid'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < STEPS.length - 1 && (
              <div
                className={`h-px flex-1 mx-0.5 ${isPast || isActive ? 'bg-neutral-300' : 'bg-neutral-200'}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
